import { useQuery } from "@tanstack/react-query";
import { getSuggestions } from "./committedClubApi";
import { useCallback, useMemo, useState } from "react";
import { NameSuggestionsQueryResult } from "./types";

export function useNameSuggestionsQuery(): NameSuggestionsQueryResult {
  const [currentIndex, setCurrentIndex] = useState(0);

  const query = useQuery({
    queryKey: ["cc-name-suggestions"],
    queryFn: getSuggestions,
  });

  const nextPage = useCallback(() => {
    if (!query.data) return;

    const nextIndex = currentIndex + 8;
    if (nextIndex >= query.data.length) {
      query.refetch();
      setCurrentIndex(0);
    } else {
      setCurrentIndex(nextIndex);
    }
  }, [currentIndex, query]);

  const visibleData = useMemo(() => {
    if (!query.data) return undefined;
    return query.data.slice(currentIndex, currentIndex + 8);
  }, [query.data, currentIndex]);

  return {
    ...query,
    data: visibleData,
    nextPage,
  };
}
